import ImageIcon from '@mui/icons-material/Image';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { Box, Typography } from '@mui/material';

import ContainerLoading from 'portal/src/components/common/ContainerLoading';

const ImgPreviewContainer = ({
  previewSrc,
  isFetchingImg,
  isPdf,
  addBackground = false,
}: {
  previewSrc: string | null;
  isFetchingImg: boolean;
  isPdf: boolean;
  addBackground?: boolean;
}) => {
  const containerStyles = {
    width: '100%',
    height: '100%',
    backgroundColor: addBackground ? 'grey.100' : 'background.paper',
    p: addBackground ? 2 : 0,
    border: addBackground ? 1 : 0,
    borderColor: 'divider',
    borderRadius: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  };

  if (isFetchingImg) {
    return (
      <Box sx={containerStyles}>
        <ContainerLoading additionalLoadingText="image" />
      </Box>
    );
  }

  if (!previewSrc) {
    return (
      <Box sx={containerStyles}>
        {isPdf ? (
          <PictureAsPdfIcon color="error" fontSize="large" />
        ) : (
          <ImageIcon color="error" fontSize="large" />
        )}
        <Typography color="error">Unable to load image preview.</Typography>
      </Box>
    );
  }

  return (
    <Box sx={containerStyles}>
      {isPdf ? (
        <iframe
          title="Image Preview"
          src={previewSrc}
          style={{
            width: '100%',
            height: addBackground ? '100vh' : '100%',
            border: 0,
            display: 'block',
          }}
        />
      ) : (
        <img
          src={previewSrc}
          alt="Image Preview"
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      )}
    </Box>
  );
};

export default ImgPreviewContainer;
